import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { filter } from 'rxjs/operators';
import { CbtserviceService } from '../services/cbtservice.service';
import { ExamService } from '../services/exam.service';
import { ProctoringService } from '../services/proctoring.service';
import { QuestionserviceService } from '../services/questionservice.service';
import { ExamAndQuestions, ScheduleQuestionAndOptions } from '../models/Exam';
import { LanguageService } from '../services/language.service';

@Component({
  selector: 'app-questionlist',
  templateUrl: './questionlist.component.html',
  styleUrls: ['./questionlist.component.css']
})
export class QuestionlistComponent implements OnInit {
  scheduleid: any;
  examid: any;
  groupedQuestionsArray: any[] = [];
  previousurl
  loading: boolean = false;
  onblurfunction;
  onfocusfunction;
  countdown: any;
  lossactionmsg: string = "";
  losscount: number = 0;
  focuslosswarningmessage: string = ""
  lostfocus: boolean = false
  examData: any = {};
  constructor(public toastr: ToastrService, public activaterouter: ActivatedRoute, public router: Router, public examservice: ExamService, public cbtservice: CbtserviceService, private proctorservice: ProctoringService, public questionservice: QuestionserviceService, private languageService: LanguageService,) { }

  get language() {
    return this.languageService.language;
  }
  async ngOnInit() {
    try {
      this.loading = true;
      this.scheduleid = this.activaterouter.snapshot.queryParams.scheduleid;
      this.examid = this.activaterouter.snapshot.queryParams.examid;
      this.previousurl = this.cbtservice.getPreviousUrl();
      // console.log(JSON.stringify(this.questions));

      this.examData = history.state.examData;//using this when navigating within same parent route
      if (!this.examData || !this.examData.examid) {
        this.goBack();
      }

      let savedQuestion = await this.questionservice.getAllQuestionDataFromStorage(this.scheduleid, this.examData.liteMode, this.examData.useCaptcha, this.examid);
      //add answered questions.
      for (let i = 0; i < savedQuestion.questions.length; i++) {
        let question = savedQuestion.questions[i];
        let answered;
        if (this.examData.examtype != this.questionservice.Essay) {
          answered =
            !!localStorage.getItem(
              `answerquestion_${savedQuestion.questions[i].examQuestion.schedulequestionid}`
            ) || savedQuestion.questions[i].examQuestion.answered;
        } else {
          const hasSubQuestions = question.examQuestion.hasessaysubquestions ||
            question.examEssaySubQuestions?.length > 0;
          if (hasSubQuestions) {
            answered = question.examEssaySubQuestions.some(subQuestion => {
              const answer = this.questionservice.getEssayAnswerFromStorage(
                question.examQuestion.schedulequestionid,
                subQuestion.essaysubquestionid);
              return this.questionservice.essayAnswerIsNotBlank(answer);
            });
          } else {
            const answer = this.questionservice.getEssayAnswerFromStorage(
              question.examQuestion.schedulequestionid);
            answered = this.questionservice.essayAnswerIsNotBlank(answer);
          }
        }
        let data = await this.questionservice.getquestionandoptions(
          question.examQuestion.questionno,
          this.examData.liteMode,
          this.examData.useCaptcha,
          this.scheduleid,
          this.examData.examid
        );
        savedQuestion.questions[i] = data;
        savedQuestion.questions[i].examQuestion.answered = answered;
      }

      const groupedQuestions = savedQuestion.questions.reduce((acc, curr) => {
        const category = curr.examQuestion.category || '';
        if (!acc[category]) {
          acc[category] = [];
        }
        acc[category].push(curr);
        return acc;
      }, {} as Record<string, any[]>);
      // Convert to an array of { category, questionList }
      this.groupedQuestionsArray = Object.entries(groupedQuestions).map(([category, questionList]) => ({
        category,
        questionList
      }));

      if (this.examData.checkfocusloss && !this.onblurfunction/* && admintestlogin != "True"*/) {
        this.onblurfunction = this.onBlur.bind(this);//have to do it this way because if i just set the event listener to this.setTileSize, the "this" becomes window
        this.onfocusfunction = this.onFocus.bind(this);
        window.addEventListener('focus', this.onfocusfunction);
        window.addEventListener('blur', this.onblurfunction);
      }
    } catch (error) {
      this.cbtservice.showHttpError(error);
    } finally {
      this.loading = false
    }
  }
  ngOnDestroy(): void {
    if (this.onblurfunction) {
      window.removeEventListener('focus', this.onfocusfunction);
      window.removeEventListener('blur', this.onblurfunction);
    }
  }
  goBack() {
    this.router.navigateByUrl(this.cbtservice.getPreviousUrl());
  }
  onFocus() {
    clearTimeout(this.countdown);
    console.log('OnPageVisibilityChange => visible');
    if (this.lostfocus && this.focuslosswarningmessage != '') {
      this.toastr.warning(this.focuslosswarningmessage);
    }
  };
  onBlur() {
    if (this.examData.checkfocusloss && !this.proctorservice.chatopened) {
      let audio = new Audio();
      audio.src = "/assets/beep.mp3";
      audio.loop = false;
      audio.load();
      audio.play();
      console.log("audio played");
      const mythis = this;
      this.countdown = setTimeout(() => {
        //debugger;
        // if (!mythis.proctorservice.chatopened) {
        //   this.setres();
        // }
        // if ((this.examination.nooffocusloss - this.losscount) === 1) {
        //   audio.play();
        //   console.log("audio played")
        // }
      }, 1000 * this.examData.durationofloss);
    }
  }

  gotoquestion(scheduleid, questionno) {
    try {
      this.router.navigate(['/exam/question'], {
        queryParams: {
          scheduleid: scheduleid,
          questionno: questionno,
          examid: this.examid,
        },
      });

    } catch (error) {
      this.cbtservice.showHttpError(error);
      throw error;
    }
  }
}